import { useBranding } from "../branding";

export function usePortalName() {
  const { data: branding } = useBranding();

  return `${branding?.company_name || ""} ${branding?.product_name || ""}`;
}
